// Borradores de editores (programas/recetarios/recetas) en localStorage: si el modal se cierra,
// se cancela o se apaga el PC, el texto escrito no se pierde. Se limpia SOLO al guardar con éxito.
// Nota: no persiste archivos (File) — solo campos de texto.

export const loadDraft = (key) => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const saveDraft = (key, obj) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(obj));
  } catch (e) {
    // Cuota llena o modo privado: el borrador es best-effort, no rompemos el flujo.
  }
};

export const clearDraft = (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    // no-op
  }
};
